import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Container, Input, InputGroup, Row, Modal, ModalHeader, ModalBody, ModalFooter, Label, Form, FormGroup,Button as RSButton, } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaPlusCircle, FaRegEye, FaRegEdit, FaRegTrashAlt, FaPhoneAlt, FaExternalLinkAlt } from "react-icons/fa";
import axios from 'axios';
import DesignDataObj from './DesignationDataInfo';
import CompanySelector from "ATSComponents/Common/CompanySelector";
import SuccessErrorPopup from "ATSComponents/Common/SuccessErrorPopup";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import { useForm } from "react-hook-form";

const DesignationView = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm();
    const designationNameInputRef = useRef(null);
    const designationNameRegister = register("designationName", { required: "Designation name is required" });
    const [DesignObjData, setDesignObjData] = useState([]);
    const [companyData, setCompanyData] = useState([]);

    const [loading, setLoading] = useState(true);

    const [AddDesignationModal, setAddDesignationModal] = useState(false);
    const [backdrop, setBackdrop] = useState(true);
    const [keyboard, setKeyboard] = useState(true);

    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));

    const isStandalone = userInfos.user_details?.companies_data?.some(
        (c) => c.integration_type === "standalone"
    );

    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
    const [companies, setCompanies] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDept, setSelectedDept] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const filteredDesignations = DesignObjData.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
        item.name?.toLowerCase().includes(term) ||
        item.description?.toLowerCase().includes(term) ||
        String(item.designation_id).includes(term)
    );
});
const formatDateTime = (dateString) => {
  if (!dateString) return "--";

  const date = new Date(dateString);

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // change to false if you want 24-hour format
  });
};  


    const AddDesignationCall = () => setAddDesignationModal(!AddDesignationModal);

    const changeBackdrop = (e) => {
        let { value } = e.target;
        if (value !== 'static') {
            value = JSON.parse(value);
        }
        setBackdrop(value);
    };

    const changeKeyboard = (e) => {
        setKeyboard(e.currentTarget.checked);
    };

  const [totalRecords, setTotalRecords] = useState(0);
        const [currentPage, setCurrentPage] = useState(1);
        const [perPage, setPerPage] = useState(10);

        const getDesignation = async (companyId, page = 1, rows = 10) => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `api/v1/designationsv1/?company_id=${companyId}&page=${page}&size=${rows}`
                );
                const response_data = response.data;
                setDesignObjData(response_data.results || []);
                setTotalRecords(response_data.count || 0);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        useEffect(() => {
            if (companyId) getDesignation(companyId, currentPage, perPage);
        }, [companyId, currentPage, perPage]);

      const [first, setFirst] = useState(0); // add this state

        const onPage = (e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            setFirst(e.first);           // ✅ track first for controlled paginator
            setCurrentPage(newPage);
            setPerPage(e.rows);
        };

    // const getCompanyDetails = async () => {

    //     try {
    //         const response = await axios.get(`api/v1/companyv1?company_id=${companyId}`);
    //         const response_data = response.data
    //         if (response_data) {
    //             setCompanies(response_data.message)


    //         } else {
    //         }
    //     } catch (error) {
    //     }
    // }

    // useEffect(() => {
    //     getCompanyDetails()
    // }, [])

    // const handleCompanyChange = (e) => {
    //     const selectedId = e.target.value;
    //     setCompanyId(selectedId);
    //     const selectedCompany = companies.find((c) => c.company_id === Number(selectedId));
    //     setCompanyData(selectedCompany);
    // };

    const handleCompanyChange = (company) => {
        if (company?.company_id) {
            setCompanyId(company?.company_id);
            setCurrentPage(1);   // ✅ reset page on company change
            setFirst(0);          // ✅ reset first too
        }
    };

    const [showDeleteJobModal, setShowDeleteJobModal] = useState(false);
    const [jobToDelete, setDeptToDelete] = useState(null);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const handleCloseErrorModal = () => setErrorAlert(false);

    const openDeleteJobModal = (id) => {
        setDeptToDelete(id);
        setShowDeleteJobModal(true);
    };
    const confirmDeleteDept = async () => {
        setDeleteLoader(true);
        try {
            await axios.delete(
                `/api/v1/designationsv1/?id=${jobToDelete}`
            );
            setShowDeleteJobModal(false);
            setDeleteLoader(false);
            getDesignation(companyId);
            setErrorMessage("Designation deleted successfully");
            setErrorAlert(true);
            setIsSuccess(true);
        } catch (err) {
            setShowDeleteJobModal(false);
            setDeleteLoader(false);
            setErrorMessage("Failed to delete");
            setErrorAlert(true);
            setIsSuccess(false);
        }
    };

    const onSubmit = async (data) => {
        // if (!companyId) {
        //     alert("Please select a company first!");
        //     return;
        // }

        const payload = {
            company_id: companyId,
            name: data.designationName,
            description: data.description,
        };

        try {
            if (selectedDept) {
                // Edit mode
                await axios.put(`/api/v1/designationsv1/?id=${selectedDept.designation_id}`, payload);
                setErrorMessage("Updated successfully");
                setErrorAlert(true);
                setIsSuccess(true);
            } else {
                // Add mode
                await axios.post(`/api/v1/designationsv1/`, payload);
                setErrorMessage("Added successfully");
                setErrorAlert(true);
                setIsSuccess(true);
            }

            getDesignation(companyId);
            setModalOpen(false);
            reset();
        } catch (error) {
            console.error("Error saving department:", error);
        }
    };
    // Hrms Design code
    // const [HrmsDesignObjData, setHrmsDesignObjData] = useState(HrmsDesignDataObj)
    const handleAddClick = () => {
        setSelectedDept(null);
        reset();
        setModalOpen(true);
    };

    const handleEditClick = (dept) => {
        setSelectedDept(dept);
        setValue("designationName", dept.name);
        setValue("description", dept.description);
        setModalOpen(true);
    };
    const focusDesignationNameInput = () => {
        setTimeout(() => {
            designationNameInputRef.current?.focus();
        }, 0);
    };

    const actionTemplate = (rowData) => (
        <div className="d-flex justify-content-center gap-2">
            <Button
                color="light"
                size="sm"
                onClick={() => handleEditClick(rowData)}
                title="Edit Designation"
                style={{ border: "1px solid #dbeafe", color: "#0f5fa8", borderRadius: 6 }}
            >
                <FaRegEdit />
            </Button>
            <Button
                color="light"
                size="sm"
                onClick={() => openDeleteJobModal(rowData.designation_id)}
                title="Delete Designation"
                style={{ border: "1px solid #fee2e2", color: "#dc2626", borderRadius: 6 }}
            >
                <FaRegTrashAlt />
            </Button>
        </div>
    );
    return (
        <React.Fragment>
            <div className="page-content allact-tabs manager-dash">
                <Container fluid>
                    <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
                        <Row className="align-items-center mb-3">
                            <Col xxl={5} xl={5} lg={12}>
                                <div>
                                    <h1 className="page-title mb-1">Designations</h1>
                                    <div style={{ color: "#64748b", fontSize: 13 }}>
                                        Manage designation masters for the selected company.
                                    </div>
                                </div>
                            </Col>
                            <Col xxl={7} xl={7} lg={12}>
                                <div
                                    className="d-flex justify-content-end align-items-center flex-wrap"
                                    style={{
                                        gap: 10,
                                        background: "#fff",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: 8,
                                        padding: "10px 12px",
                                        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
                                    }}
                                >
                                    <label className="mb-0" style={{ color: "#334155", fontWeight: 600, fontSize: 13 }}>Company</label>
                                    <div style={{ width: "180px" }}>
                                        {/* <Input className="mb-3" type="select" value={companyId} onChange={handleCompanyChange}>
                                            {companies.map((company) => (
                                                <option key={company.company_id} value={company.company_id}>
                                                    {company.company_domain}
                                                </option>
                                            ))}
                                        </Input> */}
                                        <CompanySelector onCompanyChange={handleCompanyChange} />
                                        {/* <Input className="mb-3" type="select">
                                            <option value="1" selected>PSS</option>
                                            <option value="2">VGTS</option>
                                            <option value="3">Varun Digital</option>
                                            <option value="4">MSCD</option>
                                        </Input> */}
                                    </div>
                                    <Button
                                        className='btn btn-secondary import-res-btn'
                                        onClick={() => handleAddClick()}
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            borderRadius: 6,
                                            padding: "7px 12px",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        <FaPlusCircle size={13} /> Create Designation
                                    </Button>
                                    <div style={{ width: "190px" }}>
                                            <input
                                                type="search"
                                                className="form-control"
                                                placeholder="Search designations"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                style={{ borderRadius: 6, fontSize: 13 }}
                                            />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {loading ? (
                            <OrgTableShimmer columns={isStandalone ? 2 : 1} rows={7} titleWidth="190px" />
                        ) : (
                            <Row>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <div
                                        style={{
                                            background: "#fff",
                                            border: "1px solid #e2e8f0",
                                            borderRadius: 8,
                                            overflow: "hidden",
                                            boxShadow: "0 2px 10px rgba(15, 23, 42, 0.05)",
                                        }}
                                    >
                                  <DataTable
                                        id="AllEmployees_TableView"
                                        value={DesignObjData}
                                        lazy
                                        paginator
                                        paginatorPosition="bottom"
                                        rows={perPage}
                                        first={first}               // ✅ use first state, not calculated value
                                        totalRecords={totalRecords}
                                        onPage={onPage}
                                        rowsPerPageOptions={[10, 20, 30, 50,totalRecords]}
                                        paginatorTemplate="RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
                                        scrollable
                                        scrollHeight="500px"
                                    >
                                        <Column field="name" header="Designation" sortable />
                                        <Column
                                            field="created_by_name"
                                            header="Created By"
                                            body={(rowData) => rowData.created_by_name || "--"}
                                            sortable
                                        />
                                        <Column
                                            field="created_at"
                                            header="Created At"
                                            body={(rowData) => formatDateTime(rowData.created_at)}
                                            sortable
                                        />
                                        <Column header="Actions" body={actionTemplate} />
                                    </DataTable>
                                    </div>

                                </Col>
                            </Row>
                        )}    
                    </div>
                </Container>
            </div>

            {/* Add Designation Popup */}



            {/* ✅ Add/Edit Modal */}
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered backdrop={backdrop} keyboard={keyboard} onOpened={focusDesignationNameInput}>
                <ModalHeader
                    toggle={() => setModalOpen(!modalOpen)}
                    className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
                    style={{ borderBottom: 0, padding: "14px 18px" }}
                >
                    {selectedDept ? "Edit Designation" : "Add Designation"}
                </ModalHeader>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody style={{ padding: "22px 24px 8px" }}>
                        {/* --- Department Name --- */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold" style={{ fontSize: 13 }}>
                                Name of Designation <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter designation name"
                                style={{ borderRadius: 6 }}
                                {...designationNameRegister}
                                ref={(element) => {
                                    designationNameRegister.ref(element);
                                    designationNameInputRef.current = element;
                                }}
                            />
                            {errors.designationName  && (
                                <small className="text-danger">{errors.designationName .message}</small>
                            )}
                        </div>

                        {/* --- Description --- */}
                        <div className="mb-3 d-none">
                            <label className="form-label fw-semibold">Description</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter description"
                                {...register("description")}
                            />
                        </div>
                    </ModalBody>

                    <ModalFooter className="justify-content-center" style={{ borderTop: 0, padding: "14px 24px 22px", gap: 10 }}>
                        <Button color="secondary" onClick={() => setModalOpen(false)} style={{ minWidth: 88, padding: "6px 14px", fontSize: 13 }}>
                            Cancel
                        </Button>
                        <Button color="warning" type="submit" style={{ minWidth: 128, padding: "6px 14px", fontSize: 13, fontWeight: 700 }}>
                            {selectedDept ? "Update Designation" : "Add Designation"}
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>

            {/* ---------- Delete Job Confirmation Modal ---------- */}
            <Modal isOpen={showDeleteJobModal} toggle={() => setShowDeleteJobModal(!showDeleteJobModal)} centered>
                <ModalHeader toggle={() => setShowDeleteJobModal(!showDeleteJobModal)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header" style={{ borderBottom: 0, padding: "14px 18px" }}>
                    Confirm Delete
                </ModalHeader>
                <ModalBody style={{ padding: "24px 24px 8px", textAlign: "center" }}>
                    <div style={{ color: "#dc2626", fontSize: 34, marginBottom: 10 }}>
                        <FaRegTrashAlt />
                    </div>
                    <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: 6 }}>
                        Delete designation?
                    </div>
                </ModalBody>
                <ModalFooter className="justify-content-center" style={{ borderTop: 0, padding: "14px 24px 22px", gap: 10 }}>
                    <RSButton color="secondary" onClick={() => setShowDeleteJobModal(false)} style={{ minWidth: 88, fontSize: 13 }}>
                        Cancel
                    </RSButton>
                    <RSButton color="danger" onClick={confirmDeleteDept} disabled={deleteLoader} style={{ minWidth: 88, fontSize: 13, fontWeight: 700 }}>
                        {deleteLoader ? "Deleting.." : "Delete"}
                    </RSButton>
                </ModalFooter>
            </Modal>
            {/* ---------- Error Modal ---------- */}

            <SuccessErrorPopup
                show={errorAlert}
                handleClose={handleCloseErrorModal}
                errorMessage={errorMessage}
                isSuccess={isSuccess}
            />
        </React.Fragment>
    )
}

export default DesignationView;
